import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageMapRoutingModule } from './manage-map-routing.module';
import { ManageMapComponent } from './manage-map.component';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { FileUploadModule } from 'ng2-file-upload';
import { MapFormComponent } from './components/map-form/map-form.component';
import { LocaleModule } from '../locale/locale.module';
import { CustomRouteMapPreviewComponent } from './components/custom-route-map-preview/custom-route-map-preview.component';
import { MapMarkerInfoFormComponent } from './components/map-marker-info-form/map-marker-info-form.component';
import { ChooseMapPopUpComponent } from './components/choose-map-pop-up/choose-map-pop-up.component';

@NgModule({
  declarations: [ManageMapComponent, MapFormComponent, MapMarkerInfoFormComponent, CustomRouteMapPreviewComponent, ChooseMapPopUpComponent],
  imports: [
    CommonModule,
    ManageMapRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    FormsModule,
    FileUploadModule,
    LocaleModule
  ],
  exports: [
    MapFormComponent,
    MapMarkerInfoFormComponent,
    ChooseMapPopUpComponent,
    CustomRouteMapPreviewComponent
  ]
})
export class ManageMapModule { }

